    <template>

    <crud-container :name="name">

        <crud-nav>
            <crud-nav-header title="Contacts" searchable="true"></crud-nav-header>
            <!-- @todo Change The Above Title -->

            <crud-nav-scroll>
                <ul>
                    <li v-for="contact in items">
                        <div class="name">
                            <a href="#" @click.prevent="viewItem(contact)">{{ contact.firstname }} {{ contact.lastname
                                }}</a>
                        </div>
                    </li>
                    <!-- @todo Remove the below if not using infiniload -->
                    <li>
                        <infinite-loading @infinite="loadMoreItems" ref="infiniteLoading">
                            <span slot="no-more">
                              End Of Contacts
                            </span>
                        </infinite-loading>
                    </li>
                </ul>
            </crud-nav-scroll>
        </crud-nav>

        <crud-main>
            <crud-new>
                <crud-main-header title="Create New Contact" can-go-back-to-nav="true"></crud-main-header>
                <!-- @todo Change The Above Title -->

                <crud-errors :errors="errors"></crud-errors>

                <!-- Create Form Here -->

                <div class="action-button-group">
                    <a href="#" class="action-button action-button-dismiss hidden-desktop" @click.prevent="backToNav()">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
                    </a>
                    <a href="#" class="action-button action-button-success" @click.prevent="addItem()">
                        <i class="fa fa-plus-square-o" aria-hidden="true"></i> Create Contact
                        <!-- @todo Change The Above Wording -->
                    </a>
                </div>

            </crud-new>
            <crud-edit>
                <crud-main-header :title="'Editing: '+current_item.name" can-delete="true" can-edit="true" can-go-back="true" :item="current_item"></crud-main-header>
                <!-- @todo Change The Above Title -->

                <crud-errors :errors="errors"></crud-errors>

                <!-- Update Data Here -->

                <div class="action-button-group">
                    <a href="#" class="action-button action-button-dismiss" @click.prevent="backToItem()">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
                    </a>
                    <a href="#" class="action-button action-button-success" @click.prevent="saveItem()">
                        <i class="fa fa-check" aria-hidden="true"></i> Update Contact
                        <!-- @todo Change The Above Wording -->
                    </a>
                </div>

            </crud-edit>
            <crud-view>
<!--                <crud-main-header :title="current_item.name" can-delete="true" can-edit="true" can-go-back-to-nav="true" :item="current_item"></crud-main-header>-->
                <!-- @todo Change The Above Title -->

                <!-- View Data Here -->

            </crud-view>
        </crud-main>

    </crud-container>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading'; // @todo - Remove if not using infiniload

    export default {
        components: {
            InfiniteLoading, // @todo - Remove if not using infiniload
        },
        data() {
            return {
                name:'contacts', // @todo - Change this
                items: [],
                current_item:{},
                new_item:{},
                nextPaginationUrl: '', // @todo - Remove if not using infiniload
                search_query: null, // @todo - Remove if not using search
                errors:null
            }
        },
        watch: {
            // @todo - Remove if not using infiniload
            nextPaginationUrl: function () {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
            }
        },
        computed: {
            // @todo - Remove if not using search
            has_query(){
                return this.search_query != '' && !_.isNull(this.search_query);
            }
        },
        methods: {
            saveItem: function () {
                var that = this;
                var editingItem = $.extend({}, this.current_item);
                var formDataObject = new FormData();
                var saveUrl = appUrls.contacts.update.replace('REPLACEME', editingItem.id); // @todo Change This

                _.forIn(editingItem, function(value, key) {
                    if( !_.isNull(value) )
                    {
                        formDataObject.append(key, value);
                    }
                });

                // Any other uploads or stuff can go here
                // Example: formDataObject.append('avatar', this.$refs.replaceAvatar.files[0]);

                // @todo - Form Method - Ensure this is correct
                formDataObject.append('_method', 'put');

                axios.request({
                    method: 'post',
                    url: saveUrl,
                    data: formDataObject,
                    config: {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                }).then(response => {
                    that.viewItem(response.data.data);

                }).catch(function (error) {
                    if (error.response.status === 422) {
                        that.errors = error.response.data.errors;
                    }
                });
            },

            deleteItem(itemToDelete) {
                var that = this;
                var title = 'Are you sure you want to delete "' + itemToDelete.name + '"?'; // @todo Ensure this makes sense
                var description = 'Deleting this user is irreversible. Are you sure you want to delete it?';  // @todo Ensure this makes sense
                var standardCallback = function(itemToDelete){
                    let index = that.items.indexOf(itemToDelete);
                    that.items.splice(index, 1);

                    eventBus.$emit('crud-show-new-'+that.name);
                    eventBus.$emit('crud-back-to-nav-'+that.name);
                };

                eventBus.$emit('delete-modal-open', title, description, function () {
                    axios.delete(appUrls.contacts.destroy.replace('REPLACEME', itemToDelete.id)); // @todo Change this!
                    standardCallback(itemToDelete);
                });
            },
            resetErrors(){
                this.errors = null;
            },
            addItem() {
                var that = this;
                var data = $.extend({}, this.new_item);
                var formDataObject = new FormData();
                var addUrl = appUrls.contacts.store; // @todo Change This

                var standardCallback = function(item){
                    that.items.push(item);
                    that.viewItem(item);

                };

                // Loop the elements in the new_item object and add to the formData object
                _.forIn(data, function(value, key) {
                    if( !_.isNull(value) )
                    {
                        formDataObject.append(key, value);
                    }
                });

                // Any other file uploads or bits can go here
                // Example: formDataObject.append('avatar', this.$refs.createAvatar.files[0]);

                axios.request({
                    method: 'post',
                    url: addUrl,
                    data: formDataObject,
                    config: {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                }).then(response => {
                    standardCallback(response.data.data);

                    // Any other custom methods here.
                }).catch(function (error) {
                    if (error.response.status === 422) {
                        that.errors = error.response.data.errors;
                    }
                });
            },

            // The Big Daddy Of Methods - Retrieves all methods.
            getItems(){
                var that = this;
                var url = appUrls.contacts.index; // @todo Change This
                var getVarName = 'contact'; // @todo Change This
                var params = {};

                if (this.has_query) {
                    params.query = this.search_query;
                }

                axios.get(url, {params: params})
                    .then(response => {
                        that.items = response.data.data;
                        that.nextPaginationUrl = response.data['meta']['pagination']['_links']['next']; // @todo - Remove if not using infiniload
                        var hasGetVariable = location.search.indexOf(getVarName+'=') >= 0;
                        if (hasGetVariable) {
                            var idFromVariable = getParameterByName(getVarName);
                            if (fieldWithValueExistsInCollection(that.items, 'id', idFromVariable)) {
                                that.viewItem(getItemByFieldAndValue(that.items, 'id', idFromVariable));
                            } else {
                                that.getAndViewItemById(idFromVariable); // @todo Remove this if we dont want to get from API
                            }
                        }
                    });
            },

            // @todo Keep this if you plan on making it possible to retrieve a record by ID from the API.
            // if not, remove it.
            getAndViewItemById(id) {
                var that = this;
                var url = appUrls.contacts.show.replace('REPLACEME', id);

                axios.get(url)
                    .then(response => {
                        that.viewItem(response.data.data);
                    });
            },
            viewItem(item){
                window.eventBus.$emit('crud-view-item-'+this.name,item);
            },

            // @todo Use this if you are using infini-load, otherwise remove it.
            loadMoreItems: _.debounce(function ($state) {
                var that = this;

                if (_.isNull(that.nextPaginationUrl) || that.nextPaginationUrl === '') {
                    $state.loaded();
                    $state.complete();
                    return;
                }

                axios.get(that.nextPaginationUrl)
                    .then(response => {
                        that.items = that.items.concat(response.data.data);
                        if (_.isNull(response.data.meta.pagination._links.next)) {
                            $state.complete();
                        } else {
                            that.nextPaginationUrl = response.data.meta.pagination['_links']['next'];
                            $state.loaded();
                        }
                    });
            }, 500),
            backToNav: function(){
                window.eventBus.$emit('crud-back-to-nav-'+this.name);
            },
            backToItem: function(){
                window.eventBus.$emit('crud-back-'+this.name);
            }
        },
        mounted() {
            var that = this;

            this.getItems();

            window.eventBus.$on('crud-errors-dismissed', function () {
                that.errors = null;
            });
            window.eventBus.$on('crud-search-query-changed-'+this.name, _.debounce(function (query) {
                that.search_query = query;
                that.getItems();
            }, 250));

            window.eventBus.$on('crud-search-hidden-'+this.name, function (query) {
                that.search_query = null;
                that.getItems();
            });

            window.eventBus.$on('crud-edit-item-'+this.name, function (item) {
                this.new_item = {};
                this.current_item = item;
                that.resetErrors();
            });

            window.eventBus.$on('crud-delete-item-'+this.name, function (item) {
                that.deleteItem(item);
                that.resetErrors();
            });

            window.eventBus.$on('crud-view-item-'+this.name, function (item) {
                that.new_item = {};
                that.current_item = item;
                that.resetErrors();
            });

            window.eventBus.$on('crud-back-'+this.name, function (item) {
                that.current_item = item;
                that.viewItem(item);
                that.resetErrors();
            });

            window.eventBus.$on('crud-back-to-nav-'+this.name, function () {
                that.current_item = {};
                that.new_item = {};
                that.resetErrors();
            });
        }
    }
</script>

<style lang="scss">
    /*SASS Goes Here*/
    @import '../../sass/setup';
</style>